import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import flex from 'styles/flex'
import sizing from 'styles/sizing'
import parseBackgroundPosition from 'utils/global/parseBackgroundPosition'
import colors from 'utils/styling/colors'
import zLayers from 'utils/styling/zLayers'

export const ProductPrint = styled.div(
  ({
    padding,
    whiteBorder,
    pageLayout,
    backgroundImageUrl,
    isBackgroundPreprinted,
    clipPath,
    $transparentBackground,
  }) => css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    /* 
     * Proofs (clipPath = true): Use rgba(0, 0, 0, 0.1) to create a subtle 
     * gray tint that clearly indicates this is a proof version, not final.
     * A transparent print background paints nothing behind the design.
     */
    background-color: ${$transparentBackground
      ? 'transparent'
      : clipPath
        ? 'rgba(0, 0, 0, 0.1)'
        : '#ffffff'};
    position: relative;
    ${sizing}
    overflow: hidden;
    background-image: ${pageLayout?.hide_background || isBackgroundPreprinted
      ? ''
      : `url(${backgroundImageUrl})`};
    background-size: ${pageLayout?.background_fill
      ? pageLayout.background_fill
      : 'cover'};
    background-position: ${parseBackgroundPosition(
        pageLayout?.background_left,
      )}px
      ${parseBackgroundPosition(pageLayout?.background_top)}px;
    background-repeat: no-repeat;
    border: ${whiteBorder && `${whiteBorder}px solid white`};
    padding-top: ${padding?.top && `${padding.top}px`};
    padding-right: ${padding?.right && `${padding.right}px`};
    padding-bottom: ${padding?.bottom && `${padding.bottom}px`};
    padding-left: ${padding?.left && `${padding.left}px`};
    position: relative;
    ${clipPath && `clip-path: ${clipPath};`}
    &:after {
      content: '';
      height: 100%;
      width: 100%;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      position: absolute;
      background: white;
      opacity: ${pageLayout?.background_opacity || 0};
    }
  `,
)

export const PagePrint = styled.div(
  ({
    height,
    width,
    padding,
    margin,
    clipBackgroundColor,
    $transparentBackground,
  }) => css`
    ${flex}
    background-color: ${$transparentBackground
      ? 'transparent'
      : clipBackgroundColor || '#ffffff'};
    box-shadow: ${clipBackgroundColor || $transparentBackground
      ? 'none'
      : '0px 1px 4px rgba(0, 0, 0, 0.2)'};
    height: ${height}px;
    width: ${width}px;
    padding-top: ${padding.top ? `${padding.top}px` : '0px'};
    padding-bottom: ${padding.bottom
      ? `${padding.bottom}px`
      : `${padding.top}px`};
    padding-left: ${padding.left ? `${padding.left}px` : '0px'};
    padding-right: ${padding.right ? `${padding.right}px` : '0px'};
    margin: ${margin};
    overflow: hidden;
  `,
)

export const RBDiv = styled.div(
  ({ product, isEven }) => css`
    position: absolute;
    z-index: ${zLayers.default};
    height: ${product?.productSize?.height}px;
    width: ${!isEven
      ? product?.padding.left + 1
      : product?.padding?.right + 1}px;
    background-color: #fff;
    ${isEven && `right: -1px;`}
    ${!isEven && `left: -1px;`}
    top: 0px;
  `,
)

export const RelativeWrapper = styled.div(
  () => css`
    position: relative;
  `,
)

export const PerfGuide = styled.div(
  ({ height, width, padding, whiteBorder, hideOverflow }) => css`
    height: ${whiteBorder
      ? height - whiteBorder * 2
      : height - padding?.top - padding?.bottom}px;
    width: ${whiteBorder
      ? width - whiteBorder * 2
      : width - padding?.left - padding?.right}px;
    overflow: ${hideOverflow ? 'visible' : 'hidden'};
    position: relative;
  `,
)

export const NoPrint = styled(Flex)`
  position: absolute;
  background-color: ${colors('gray4')};
`
